var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-box"},[_c('ul',{staticClass:"list"},_vm._l((_vm.res_list),function(list){return _c('li',{key:list.attributes.OBJECTID},[_c('list_card',{attrs:{"Name":list.attributes.Name,"Address":list.attributes.Address,"Tel":list.attributes.Tel,"OBJECTID":list.attributes.OBJECTID}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440bbb06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zwfwmap-phone/left_zrzyjfj_list/left_zrzyjfj_list.vue
// module id = null
// module chunks = 